<template>
  <span v-if="!editing" class="editable-label" @click="edit">
    {{ valueFormatted }}
    <i class="fa fa-edit"></i>
  </span>

  <div v-else class="l-row">
    <div class="l-col-7@md">
      <money v-if="Object.keys(moneyTypes).indexOf(type) !== -1" v-model="newValue" v-bind="moneyTypes[type]" class="form-input" ref="input"/>
      <input v-else :type="type" @change="onChangeAttribute()" v-model="newValue" class="form-input" ref="input">
    </div>

    <div class="l-col-5@md no-pdd">
      <button @click="cancel" class="btn-action btn t-error btn--default no-pdd"><i class="fa fa-times"></i></button>
      <button @click="confirm" class="btn-action btn t-success btn--default no-pdd"><i class="fa fa-check"></i></button>
    </div>
  </div>
</template>

<script>
  import { cloneDeep } from 'lodash'
  import { Money } from 'v-money'

  export default {
    data: () => ({
      editing: false,
      newValue: null,
      moneyTypes: {
        price: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          precision: 2,
          masked: false
        },
        percent: {
          decimal: ',',
          thousands: '.',
          suffix: ' %',
          precision: 2,
          masked: false
        }
      }
    }),
    props: {
      label: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: 'text'
      },
      value: {
        type: [String, Number],
        required: true
      },
      onCancel: {
        type: Function,
        default: null,
        required: false
      },
      onConfirm: {
        type: Function,
        default: null,
        required: false
      },
      isEditable: {
        type: Boolean,
        default: false
      }
    },
    mounted () {
      if (this.isEditable) {
        this.edit()
      }
    },
    updated () {
      if (this.$refs.input) {
        if (this.$refs.input.$el) {
          this.$refs.input.$el.focus()
        }
      }
    },
    methods: {
      onChangeAttribute () {
        this.onConfirm(this.value, this.newValue)
      },
      edit () {
        this.newValue = cloneDeep(this.value)
        this.editing = true
      },
      cancel () {
        this.editing = false

        if (this.onCancel) {
          this.onCancel()
        }
      },
      confirm () {
        if (this.value === this.newValue) {
          return false
        }

        this.editing = false
        if (this.onConfirm) {
          this.onConfirm(this.value, this.newValue)
        }
      }
    },
    computed: {
      valueFormatted () {
        switch (this.type) {
          case 'price':
            return this.$options.filters.currency(this.value)

          case 'percent':
            return this.value + '%'

          default:
            return this.value
        }
      }
    },
    watch: {
      '$refs.input.$el' () {
        console.log('watch')
      }
    },
    components: {
      Money
    }
  }
</script>

<style lang="sass" scoped>
  .editable-label
    color: #0073AA
    cursor: pointer
    padding-bottom: 2px
    border-bottom: 1px dashed #0073AA

    &:hover
      color: #005177

  .btn-action
    display: inline-block
    width: 45%

  .no-pdd
    padding: 0
</style>



// WEBPACK FOOTER //
// Base.vue?f64c253a